import { observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IGlobalSearchChangeDetail } from '../../../models/commonTypes';

export class SearchStore extends StoreBase {

	@observable searchTerm: string = '';

	public initialize(): Promise<void> {
		throw new Error('Method not implemented.');
	}

	/**
	 * This method will search for global search values based on events received from a global search app, and trigger the updates
	 *
	 * @param identifier
	 * @param [storageType]
	 * @param [values]
	 * @returns
	 */
	public handleUpdate = async (customEvent: CustomEvent<IGlobalSearchChangeDetail>) => {
		const { inputStore, appStore } = this.storeContext;
		const { searchTerm } = customEvent.detail;
		this.searchTerm = searchTerm;
		const values = {
			'ksys-search': searchTerm,
		};
		await inputStore.updateQueryInputs([appStore.applicationId], values);

	}
}